'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var BeachVolleyball = function (_PureComponent) {
  (0, _inherits3.default)(BeachVolleyball, _PureComponent);
  function BeachVolleyball() {
    (0, _classCallCheck3.default)(this, BeachVolleyball);
    return (0, _possibleConstructorReturn3.default)(this, (BeachVolleyball.__proto__ || (0, _getPrototypeOf2.default)(BeachVolleyball)).apply(this, arguments));
  }
  (0, _createClass3.default)(BeachVolleyball, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M32 30.4H0v-1.6h32zm-15.744-1.6H16c-7.508-.004-13.592-6.092-13.592-13.6 0-2.42.632-4.692 1.74-6.66l-.035-.012c2.373-4.167 6.786-6.93 11.843-6.93 4.908 0 9.208 2.602 11.595 6.502l.13.06a13.428 13.428 0 0 1 1.99 7.072c0 7.44-5.987 13.48-13.405 13.567zm6.272-7.168a12.505 12.505 0 0 0 1.647-6.242c0-.382-.017-.76-.05-1.134-.434-.005-.94-.035-1.453-.035s-1.02.03-1.516.09c.078.258.087.567.087.878 0 4.935-2.482 9.29-6.266 11.884l.91.032c2.832-1.04 5.133-2.963 6.625-5.43zM7.168 17.6a12.73 12.73 0 0 0 5.46 5.055c.624-.707 1.112-1.55 1.5-2.444-4.48-2.3-7.608-6.715-7.966-11.894-.194.228-.354.5-.53.788a12.42 12.42 0 0 0-.174 2.104c0 2.353.635 4.558 1.743 6.452zm11.12-11.2a12.577 12.577 0 0 0-7.21 2.267c.47.932.963 1.757 1.537 2.517 2.222-1.548 4.988-2.45 7.965-2.45 2.286 0 4.448.532 6.368 1.48-.228-.326-.372-.614-.532-.902A12.724 12.724 0 0 0 18.288 6.4zm-9.6-.576q-.448.352-.864.736a12.61 12.61 0 0 0 6.856 12.16c.34-.874.513-1.92.55-3.002-3.47-2.208-5.914-5.752-6.595-9.89zm2.8 20.496c.352.144.704.272 1.056.368 4.25-2.087 7.126-6.385 7.126-11.354 0-.26-.008-.52-.024-.778-1.093.318-2.052.7-2.945 1.188-.1 4.247-2.11 8.027-5.187 10.555zm16.384-12.8c0-.368-.128-.752-.208-1.104a12.5 12.5 0 0 0-7.08-2.175c-2.582 0-4.983.777-6.982 2.11.738.707 1.51 1.356 2.35 1.908a14.905 14.905 0 0 1 6.813-1.658c1.836 0 3.59.343 5.205.97zM16 3.2c-2.176.012-4.21.605-5.96 1.63.152.805.31 1.56.528 2.286C12.708 5.628 15.35 4.8 18.186 4.8h.107c1.718.007 3.367.318 4.894.88-2.045-1.53-4.506-2.445-7.18-2.48zM9.92 25.6a13.257 13.257 0 0 0 1.718-1.59c-2.457-1.28-4.45-3.17-5.81-5.48a14.277 14.277 0 0 1-1.72-4.65c-.075.37-.11.9-.11 1.436 0 4.368 2.355 8.186 5.866 10.252zM28 15.296a12.422 12.422 0 0 0-2.07-.7c-.076.214-.068.486-.068.76 0 2.59-.69 5.02-1.898 7.113a14.478 14.478 0 0 1-3.142 3.72c4.226-1.87 7.142-6.037 7.178-10.89z'
      }));
    }
  }]);
  return BeachVolleyball;
}(_react.PureComponent);
BeachVolleyball.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = BeachVolleyball;